import React from "react";
import { FileText, Plus } from "lucide-react";

export default function EmptyState({
  title = "Nothing here yet",
  message,
  actionLabel,
  onAction,
  Icon = FileText,
}) {
  return (
    <div className="bg-white rounded-2xl border border-dashed border-gray-200 p-10 flex flex-col items-center text-center">
      <div className="w-12 h-12 rounded-full bg-leechiuBlue/5 text-leechiuBlue flex items-center justify-center mb-3">
        <Icon className="w-6 h-6" />
      </div>
      <h3 className="text-base font-semibold text-leechiuBlue">{title}</h3>
      {message ? (
        <p className="text-sm text-gray-500 mt-1 max-w-sm">{message}</p>
      ) : null}
      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-leechiuOrange text-white text-sm font-medium hover:opacity-90"
        >
          <Plus className="w-4 h-4" />
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
